<template>
  <div class="c parking-lot-settings exceptions">
    <v-layout row wrap>
      <v-flex xs10>
        <v-select
          v-model="dataModel.type"
          :items="types"
          item-text="name"
          item-value="id"
          label="Typ"
        ></v-select>
      </v-flex>
      <v-flex class="text-align-right" xs2>
        <v-btn class="no-spacing" icon color="error" flat @click="removeException">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 v-if="dataModel.type === 'single_day'">
        <v-menu
          :close-on-content-click="false"
          v-model="datepickerMenu"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="dataModel.date"
            label="Datum"
            readonly
          ></v-text-field>
          <v-date-picker
            color="primary"
            no-title
            v-model="dataModel.date"
            @input="datepickerMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          v-model="dataModel.startTime"
          label="Zwischen"
          mask="##:##"
          suffix="Uhr"
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          label="Und"
          v-model="dataModel.endTime"
          mask="##:##"
          suffix="Uhr"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          label="Maximale Standzeit"
          v-model="dataModel.maxTime"
          suffix="Stunden"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'exceptions',

  props: {
    data: {
      type: Object,
      required: false,
    },
    index: {
      required: false,
    },
  },

  data() {
    return {
      types: [
        { name: 'Einzelner Tag', id: 'single_day' },
        { name: 'Weihnachten', id: 'christmas' },
        { name: 'Ostern', id: 'easter' },
        { name: 'Feiertage Baden-Württemberg', id: 'public_holiday_de_bw' },
        { name: 'Feiertage Bayern', id: 'public_holiday_de_by' },
        { name: 'Feiertage Berlin', id: 'public_holiday_de_be' },
        { name: 'Feiertage Brandenburg', id: 'public_holiday_de_bb' },
        { name: 'Feiertage Bremen', id: 'public_holiday_de_hb' },
        { name: 'Feiertage Hamburg', id: 'public_holiday_de_hh' },
        { name: 'Feiertage Hessen', id: 'public_holiday_de_he' },
        { name: 'Feiertage Mecklenburg-Vorpommern', id: 'public_holiday_de_mv' },
        { name: 'Feiertage Niedersachsen', id: 'public_holiday_de_ni' },
        { name: 'Feiertage Nordrhein-Westfalen', id: 'public_holiday_de_nw' },
        { name: 'Feiertage Rheinland-Pfalz', id: 'public_holiday_de_rp' },
        { name: 'Feiertage Saarland', id: 'public_holiday_de_sl' },
        { name: 'Feiertage Sachsen', id: 'public_holiday_de_sn' },
        { name: 'Feiertage Sachsen-Anhalt', id: 'public_holiday_de_st' },
        { name: 'Feiertage Schleswig-Holstein', id: 'public_holiday_de_sh' },
        { name: 'Feiertage Thüringen', id: 'public_holiday_de_th' },
      ],
      dataModel: {
        type: '',
        date: null,
        startTime: null,
        endTime: null,
        maxTime: null,
      },
      datepickerMenu: false,
    };
  },

  watch: {
    dataModel: {
      handler() {
        this.$emit('change', { index: this.index, data: this.dataModel });
      },
      deep: true,
    },
  },

  methods: {
    removeException() {
      this.$emit('delete', { index: this.index, data: this.dataModel });
    },
  },

  mounted() {
    this.dataModel = this.data;
  },
};
</script>
